import { render } from "./StageAdvertisingMix.vue?vue&type=template&id=604d6488&scoped=true"
import script from "./StageAdvertisingMix.vue?vue&type=script&lang=js"
export * from "./StageAdvertisingMix.vue?vue&type=script&lang=js"

import "./StageAdvertisingMix.vue?vue&type=style&index=0&id=604d6488&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604d6488"]])

export default __exports__